import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Styles loaded only when running the SOC bundle as its own SPA (`npm run start`).
 * The federated `SocApp` does not import these so the monolith shell keeps its PrimeFlex/layout/theme order.
 */
import 'primereact/resources/themes/bootstrap4-light-blue/theme.css';
import 'react-toastify/dist/ReactToastify.css';
import 'primeflex/themes/primeone-light.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { PrimeReactProvider } from 'primereact/api';
import { ToastContainer } from 'react-toastify';
const SocApp = lazy(() => import('./SocApp'));
createRoot(document.getElementById('root')).render(_jsxs(PrimeReactProvider, { children: [_jsx(ToastContainer, { position: "top-left", className: "toastify-container", toastClassName: "toastify-toast" }), _jsx(Suspense, { fallback: _jsxs("div", { className: "p-4 text-center", children: [_jsx("i", { className: "pi pi-spin pi-spinner", style: { fontSize: '2rem' }, "aria-hidden": true }), _jsx("p", { className: "mt-2", children: "Loading Schedule of Charges\u2026" })] }), children: _jsx(SocApp, { hostLocale: sessionStorage.getItem('locale') || 'en' }) })] }));
